import { type GetHookResponse } from '../hooks'
import { userSearchKey } from '../keys'
import { useTantalimQuery } from '../query'
import { useUserCache } from './cache'
import { HOUR, Logger, type TinyUser, type UserSearchInput, type UserSearchSuccess, isNotEmpty } from '@terros/common'

const logger = new Logger('useSearchUsers')

export function useSearchUsers(input: UserSearchInput, enabled = true): GetHookResponse<TinyUser[]> {
  logger.verbose('calling useSearchUsers', input)
  const cache = useUserCache()
  return useTantalimQuery<UserSearchInput, UserSearchSuccess, TinyUser[]>({
    url: '/user/search',
    queryKey: userSearchKey(input),
    input,
    convertResponse: (data) => {
      const users = data.users
      users.forEach((user) => {
        cache.setTinyUser(user)
      })
      return users
    },
    options: {
      gcTime: HOUR,
      staleTime: HOUR,
      enabled: (isNotEmpty(input.query) || isNotEmpty(input.options)) && enabled,
    },
  })
}
